// Hardcoded list of email addresses that are not allowed to book online.
// These customers must contact the clinic directly to schedule an appointment.
// Add addresses in lowercase.
const BLOCKED_EMAILS: string[] = [
    // "example@blocked.com",
    "yalcinsongl2015@yahoo.com", 
    "muratsongl1606@yahoo.com",
    "jaqueline.soltau@gmx.de",
    "pegah.auth@gmail.com",
    "leademir@t-online.de",
    "mernamoh16@gmail.com",
    "aram@sub.global",
    "m1idris40@gmail.com",
];

export const isEmailBlockedFromBooking = (email: string): boolean => {
    if (!email) return false;
    return BLOCKED_EMAILS.includes(email.trim().toLowerCase());
};
